import type { FaireProductEntity } from "../../entity_types/product";

export const p_aj9dn9yqbs: FaireProductEntity = {
  token: "p_aj9dn9yqbs",
  type: "product",
  name: "Patchwork Charm",
  brandToken: "b_3fza0fmxih",
  brandName: "Bel Kai",
  imageUrl:
    "https://cdn.faire.com/fastly/9bc641e9bd62a35af314588669cc00a698ecafbff83d0b373b8ecc041e78ae09.jpeg",
  galleryImageUrls: [],
  priceDollars: 6,
  description:
    'Our Patchwork pendant charm is made by hand, encasing & sealing an original image in layers of resin. Our charms are handmade, in the United States. All settings are made of a pewter base, plated with either 24K gold or .999 sterling silver.\n\nThe pendant width is .5"\n\nOption to Add a Chain - brass base chains are plated using 24k gold, or .999 fine silver and finished with a lobster claw clasp.\n',
  tags: [],
  msrpDollars: 12,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-06T20:37:41.142Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
